import { render, staticRenderFns } from "./index.vue?vue&type=template&id=604ec83c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=604ec83c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604ec83c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('604ec83c')) {
      api.createRecord('604ec83c', component.options)
    } else {
      api.reload('604ec83c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=604ec83c&scoped=true", function () {
      api.rerender('604ec83c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/homeManage/personnelDetail/index.vue"
export default component.exports